import { gql } from "@apollo/client";

export const manufacturersQuery = gql`
  query {
    rv_manufacturers
  }
`;
